import { jsx as _jsx } from "react/jsx-runtime";
import { Badge, Skeleton } from '@mui/material';
import { AvatarDefault, AvatarDefaultBadge, AvatarSkeletonMaskedContainer, } from './Avatar.style.js';
import { SmallAvatarSkeleton } from './SmallAvatar.js';
export const AvatarBadgedDefault = ({ sx }) => {
    return (_jsx(Badge, { overlap: "circular", anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, badgeContent: _jsx(AvatarDefaultBadge, {}), sx: sx, children: _jsx(AvatarDefault, {}) }));
};
export const AvatarBadgedSkeleton = ({ sx, avatarSize = 40, badgeSize = 16 }) => {
    return (_jsx(Badge, { overlap: "circular", anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, badgeContent: _jsx(SmallAvatarSkeleton, { size: badgeSize }), sx: sx, children: _jsx(AvatarSkeleton, { avatarSize: avatarSize, badgeSize: badgeSize }) }));
};
const AvatarSkeleton = ({ avatarSize, badgeSize }) => {
    return (_jsx(AvatarSkeletonMaskedContainer, { badgeSize: badgeSize, children: _jsx(Skeleton, { width: avatarSize, height: avatarSize, variant: "circular" }) }));
};
//# sourceMappingURL=Avatar.js.map